import mori from 'mori';
import { indexOf } from '../../util/util';

/**
 * Compose the footnotes into an array of hashmaps with the following keys:
 * Should be a composed key:
 * * [year, location, headergroup]
 * * [year, location, header]
 * * [year, location, #{headergroup, header}]
 *
 * @param  {mori.vector} footnotes  [footnotes from config]
 * @param  {mori.vector} timeframes [active timeframes to use]
 * @param  {mori.vector} distributions [active distributions to use]
 * @return {mori.vector}            [vector of composed footnote keys]
 */
export default function composeFootnotes(footnotes, timeframes, distributions) {
  return mori.reduceKV(
    (acc, year, yearData) => (
      indexOf(timeframes, year) ?
      mori.into(
        acc,
        mori.reduceKV(
          (acc1, state, stateData) => mori.into(
            acc1,
            mori.reduceKV(
              (acc2, dist, distData) =>
                indexOf(distributions, dist) ?
                mori.conj(
                  acc2,
                  mori.hashMap(
                    mori.set([year, state, dist]),
                    distData
                  )
                ) :
                acc2,
              mori.vector(),
              stateData
            )
          ),
          mori.vector(),
          yearData
        )
      ) :
      acc
    ),
    mori.vector(),
    footnotes
  );
}



// WEBPACK FOOTER //
// ../datacenter/app/js/services/getFootnotes/composeFootnotes.js